
















































import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import { AppUtil } from '../../utils/app.util';
import SetCode from './setCode.vue';
import userService from "@/service/userService";
import { Constants } from "@/const/Constants";
import { CryptoUtil } from "@/utils/crypto.util";
import { Getter, Action, State } from "vuex-class";
import { LocalStorageService, SessionStorageService } from "@/service/storageService";

@Component({
  components: { SetCode }
})
export default class Register extends Vue {
  private isAgree: boolean = false; // 是否同意
  private appInfoAtiak: any = userService.appInfoAtiak; // 应用信息
  private userName: string = ''; // 用户名
  private mobile: string = ''; // 手机号
  private code: string = ''; // 验证码
  private password: string = ''; // 密码
  private passwords: string = ''; // 确认密码
  private option: any = {
    handleType: 'register',
    listParam: {},
  };
  private showNotice: boolean = false;
  private showConfirm: boolean = false;
  @Action('SET_SHOW_ACCOUNT_DIALOG_ASYN') handleAccountDialog!: (data: boolean) => void
  @Action('SET_ACCOUNT_DIALOG_TYPE_ASYN') changeAccountType!: (data: string) => void

  getSendCode(res: any) { // 获取验证码
    // console.log('sendCode', res);
  }

  //检查用户名
  validUserName(): boolean {
    if (AppUtil.isEmpty(this.userName)) {
      this.$Message.error("请输入用户名!");
      return false;
    }
    return true;
  }
  //检查手机号
  validPhone(): boolean {
    if (AppUtil.isEmpty(this.mobile) || !AppUtil.isPhoneNumber(this.mobile)) {
      this.$Message.error("请输入正确手机号!");
      return false;
    }
    return true;
  }
  //检查验证码
  validCode(): boolean {
    if (AppUtil.isEmpty(this.code)) {
      this.$Message.error("请输入验证码!");
      return false;
    } else if (this.code.length != 6) {
      this.$Message.error("验证码不正确!");
      return false;
    }
    return true;
  }
  //检查是否同意协议
  validAgree(): boolean {
    if (!this.isAgree) {
      this.$Message.error("请选择同意《用户协议》和《隐私政策》!");
      return false;
    } else {
      return true;
    }
  }
  // 注册
  register() {
    if (!this.validUserName()) {
      return false;
    }
    if ((!this.validPhone() || !this.validCode())) {
      return false;
    }
    this.userName = this.userName.trim();
    const unameReg = /^[a-zA-Z0-9\u4e00-\u9fa5_-]+$/;
    const passwordReg =
      /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{8,16}$/;
    if (AppUtil.isEmpty(this.userName) || this.userName.length < 2 || this.userName.length > 16) {
      this.$Message.error("请输入2-16个字符的账号!");
      return;
    } else if (!unameReg.test(this.userName)) {
      this.$Message.error("账号仅限汉字、字母、数字、下划线、中划线!");
      return;
    } else if (AppUtil.isEmpty(this.password)) {
      this.$Message.error("密码不能为空!");
      return;
    } else if (!passwordReg.test(this.password)) {
      this.$Message.error("密码长度8~16位，须包含大、小写字母、数字、符号中任意三种元素!");
      return;
    } else if (this.password != this.passwords) {
      this.$Message.error("两次密码不一致!");
      return;
    }
    if (!this.validAgree()) {
      return false;
    }
    // 注册时，先调list接口：
    //   1.如果没有返回list，直接完成注册
    //   2.如果返回了list
    //     -1.如果选择list内的账号，使用该账号的openid和code调合并接口，不需再调注册接口
    //     -2.如果选择当前注册账号，先进行注册（手机号缓存不传给注册接口），用注册接口返回的openid和list接口返回的code调合并接口
    userService.userMobileBindList(this.mobile, this.code, this.userName).then((res: any) => {
      if (res.success) {
        const { list, result } = res
        if (list && list.length > 0) {
          this.option.listParam = {
            mobile: this.mobile,
            smsCode: this.code,
            userName: this.userName,
            password: this.password,
            atiak: userService.appInfoAtiak,
          }
          this.option.userName = this.userName
          this.showNotice = false
          setTimeout(() => {
            this.showNotice = true
          });
          return
        } else if (result && result.primary) {
          this.option.listParam = {
            code: result.code,
            ...result.primary
          }
          this.showConfirm = false
          setTimeout(() => {
            this.showConfirm = true
          });
          return
        }
        userService.registerBind(this.userName, this.password, this.appInfoAtiak, this.mobile, this.code).then((data: any) => {
          if (data && data.success) {
            LocalStorageService.set(Constants.Storage_Local.Login_Name, this.userName);
            this.openRegisterOk();
          }
          else {
            if (data.errorCode === '05152') {
              // 手机号已绑定
              SessionStorageService.set(Constants.Storage_Session.Repeat_Login_Info,
                CryptoUtil.encrypt({
                  userName: this.userName,
                  password: this.password
                }, userService.getEKey())
              );
              this.showReapetBind()
            }
            else {
              this.$Message.error(data.errorText);
            }
          }
        }).catch((err: any) => { });
      } else if (AppUtil.isNotEmpty(res.errorText)) {
        this.$Message.error(res.errorText);
      }
    })
  }

  showReapetBind() { // 手机号已绑定
    this.$Modal.confirm({
      title: '提示',
      content: '当前手机号已绑定有效账号，您可以使用此手机号直接登录。',
      onOk: () => {
        this.handleAccountDialog(true)
        this.changeAccountType('login')
      }, onCancel: () => { }
    })
  }

  openRegisterOk() { // 注册成功
    this.$Modal.confirm({
      title: '注册成功',
      content: '注册成功，请登录！',
      onOk: () => {
        this.handleAccountDialog(true)
        this.changeAccountType('login')
      },
      onCancel: () => {

      }
    });
  }
  openxy(index: number) {
    let uri = index == 0 ? "sxyyzc" : "sxyyzc";
    let title = index == 0 ? "用户协议" : "隐私政策";
    let url = "//html.chineseall.cn/assets/html/" + uri + "/index.html";
    window.open(url, "_blank");
  }
}
